export default function SendBeacon({ url }: { url: string }) {
  return <img src={`${url}&beacon=1`} style={{ display: 'none' }} />;
}
